import regionImgSrc from './regionImgSrc'
import focus from './focus'
import elementValue from './elementValue'

const directives = {
  regionImgSrc,
  focus,
  elementValue,
}

export default {
  install (Vue) {
    Object.entries(directives).forEach(([name, directive]) => {
      Vue.directive(name, directive)
    })
  },
}
